
export enum AppDatatableActionType {
    REFRESH = "refresh",
    INSERT = "insert",
    EXPAND = "expand",
    UPDATE = "update",
    DELETE = "delete",
    SORT = "sort"
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/enums/action-type.enum.ts